<script setup lang="ts">
import type { BlockHighlightsFragment } from '#graphql-operations'

interface HighlightsRendererProps {
  data: BlockHighlightsFragment
}

const props = defineProps<HighlightsRendererProps>()

const highlightsComponent = new Map([
  ['press', resolveComponent('LazyHighlightsPress')],
  ['staffMembers', resolveComponent('LazyHighlightsStaff')],
  ['news', resolveComponent('LazyHighlightsNews')],
])

const component = computed(() => highlightsComponent.get(props.data.highlightsType ?? '') ?? resolveComponent('LazyHighlightsNews'))
</script>

<template>
  <component :is="component" :data />
</template>
